<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-feriado />
    <VerFeriado />
    <ModificarFeriado />

    <h3 class="primary--text">
      <v-icon color="primary">event</v-icon> Administración de feriados
    </h3>
    <v-card>
      <v-card-text>
        <!-- <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
        > 
      
      
        -->
          <!-- Template injectable de la cabecera de la tabla -->
      
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarFeriado({})"
                slot="activator"
                ><v-icon dark>add</v-icon> NUEVO</v-btn
              >
              <span>Agregar Feriado</span>
            </v-tooltip>
        
           <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton actualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="cargarFeriados()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>

          <div class="filter-item">
            <v-text-field
              label="Fecha"
              v-model="form.fecha"
              type="date"
              @input="
                filterFecha(
                  $moment(form.fecha, 'YYYY-MM-DD').format(
                    'DD/MM/YYYY'
                  )
                )
              "
            ></v-text-field>
          </div>

          <div class="filter-item"> 
            <v-text-field
              label="Descripción"
              type="text"
              v-model="form.descripcion"
              @input="filterDescripcion(form.descripcion)"
            ></v-text-field>
          </div>
          <div class="filter-item">  
            <v-text-field
              label="Tipo"
              type="text"
              v-model="form.tipo"
              @input="filterTipo(form.tipo)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              type="text"
              v-model="form.estado"
              @input="filterEstado(form.estado)"
            ></v-text-field>
          </div>

          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                    recargar();
                  }
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <br />
          <v-data-table
								:items="feriados"
								:headers="headers"
                class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
          item-key="index"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
							>
         

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">{{ items.item.fecha }}</td>
            <!-- <td class="text-xs-center">{{ items.item.id_feriado }}</td> -->
            <td class="text-xs-center">{{ items.item.descripcion }}</td>
           
            <td class="text-xs-center" v-if="items.item.nacional == 1">
              Nacional
            </td>
            <td class="text-xs-center" v-if="items.item.nacional == 0">
              Departamental
            </td>
            <td class="text-xs-center" v-if="items.item.nacional == 2">
              Internacional
            </td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td class="nowrap text-xs-center">
              <v-btn
                color="info"
                @click.prevent="verFeriado(items.item)"
                icon
                title="Ver Feriado"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>

              <v-btn
                color="warning"
                @click.prevent="modificarFeriado(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                color="red"
                @click.prevent="eliminarFeriado(items.item.id_feriado)"
                icon
                title="Eliminar"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarFeriado from "./dialogs/CrearActualizarFeriado"; // Componente de creación y actualización
import VerFeriado from "./dialogs/VerFeriado";
import ModificarFeriado from "./dialogs/ModificarFeriado";
import Filtros from "./mixins/filtros";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud,Filtros],
  // Variables iniciales del componente
  data() {
    return {
      url: "vFeriados",
      graphql: true,
      feriados:[],
      loading: false,
      // Cabecera de la tabla
      headers: [
      { text: "Fecha", value: "fecha", align: "center" },
        // { text: "Id", value: "id_feriado", align: "center" },
        { text: "Descripción", value: "descripcion", align: "center" },
       
        { text: "Tipo", value: "nacional", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      form: {},
      // Variables filtros
      filters: {
        fecha: "",
        descripcion: "",
        tipo: "",
        estado: "",
      },
      filterShow: true,
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id_estado
        id_feriado
        descripcion
        fecha
        nacional
        estado
        id_parametro
        tipo
        valor
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      // filters: [
      //   {
      //     field: "id_feriado",
      //     label: "Id",
      //     type: "number",
      //     typeG: "String"
      //   },
      //   {
      //     field: "descripcion",
      //     label: "Descripcion",
      //     type: "text",
      //     typeG: "String"
      //   },
      //   {
      //     field: "fecha",
      //     label: "Fecha",
      //     type: "text",
      //     typeG: "String"
      //   },
      //   {
      //     field: "tipo",
      //     label: "Tipo",
      //     type: "text",
      //     typeG: "String"
      //   },
      //   {
      //     field: "estado",
      //     label: "Estado",
      //     type: "text",
      //     typeG: "String"
      //   }
      // ]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    await this.cargarFeriados();
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.onFilter()
    this.$bus.$on("closeDialog",async () => {
      await this.cargarFeriados();
    });
  },
  // Métodos y funciones del componente
  methods: {
    verFeriado(item) {
      this.$bus.$emit("openDialogVerFeriado", item);
    },
    modificarFeriado(item) {
      this.$bus.$emit("openDialogModificarFeriado", item);
    },
    async cargarFeriados(){
      try {
        this.loading = true;
        this.feriados=[]
        let respuesta = await this.$service.graphql({
          query: `
            query{
            runQuery(consulta:"select * FROM general.v_feriado"){
            respuesta
            }
            } 

 `,
        });
        respuesta = respuesta.runQuery.respuesta;
        this.feriados = respuesta;
 
      } catch (error) {
        console.log(error)
      }
      this.loading = false;
    },
   async eliminarFeriado(item) {
      try {
        let respuesta;
        this.$confirm("¿Esta seguro de eliminar el registro?", async () => {
          let user = this.$storage.get("user");
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select general.fn_elimina_feriado(${parseInt(item)},${parseInt(user.id)})"){
                  respuesta
                }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_elimina_feriado.split("|");
          if (respuesta[0] == "1") {
            this.$alert(respuesta[1], "", "Aviso");
            await this.cargarFeriados();
          } else {
            this.$alert(respuesta[1], "", "Aviso");
          }
        });
      } catch (error) {
        console.log(error);
      }
     
    },
    crearActualizarFeriado(item) {
      this.$bus.$emit("openDialogCrearActualizarFeriado", item);
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarFeriado,
    VerFeriado,
    ModificarFeriado
  }
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
.style-1 {
  background-color: rgb(191, 255, 139);
}
#style-2 {
  background: #025a66e8;
  color: white;
}</style>



// WEBPACK FOOTER //
// src/components/admin/feriado/Index.vue